import { createVNode as n, mergeProps as o } from "vue";
import s from "../node_modules/@pf-ui/pf-icon-svg/es/asn/DesignOutlined.js";
import l from "../components/PfIcon.js";
const e = (t, r) => {
  const i = {
    ...t,
    ...r.attrs
  };
  return n(l, o(i, {
    icon: s
  }), null);
};
e.displayName = "DesignOutlined";
e.inheritAttrs = !1;
export {
  e as default
};
